
import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

const CookiePolicy = () => {
  const today = new Date().toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  })

  return (
    <div className="min-h-screen bg-background py-12">
      <Helmet>
        <title>Cookie Policy | DesistIt!</title>
        <meta name="description" content="Learn about how DesistIt! uses cookies and similar technologies to improve your experience on our cease and desist letter generation platform." />
        <link rel="canonical" href="https://desistit.com/cookies" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Cookie Policy",
            "description": "DesistIt! cookie policy explaining our use of cookies and tracking technologies.",
            "publisher": {
              "@type": "Organization",
              "name": "DesistIt!",
              "logo": "https://www.poweredbyeducation.org/wp-content/uploads/2025/02/DESIST2.png"
            },
            "datePublished": today,
            "dateModified": today
          })}
        </script>
      </Helmet>
      
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-5xl font-serif font-bold mb-8 text-center">Cookie Policy</h1>
        
        <div className="text-center text-gray-600 mb-12">
          <p>Updated {today} | Published {today}</p>
          <p className="mt-4">By DesistIt! staff</p>
        </div>
        
        <div className="prose prose-lg max-w-none text-left">
          <p className="text-xl">Welcome to DesistIt! ("Company," "we," "us," or "our"). This Cookie Policy explains how we use cookies and similar tracking technologies on our website, desistit.com (the "Website"). By using our Website, you agree to the use of cookies as described in this policy.</p>
          
          <h2>1. What Are Cookies?</h2>
          <p>Cookies are small text files stored on your device when you visit a website. They help websites function properly, improve user experience, and provide analytical insights.</p>
          
          <h2>2. Types of Cookies We Use</h2>
          <p>We use the following types of cookies:</p>
          <ul>
            <li><strong>Essential Cookies:</strong> Necessary for the basic functionality of our Website, such as security and accessibility.</li>
            <li><strong>Analytical Cookies:</strong> Help us understand how visitors interact with our Website, enabling us to improve functionality and user experience.</li>
            <li><strong>Functional Cookies:</strong> Allow us to remember your preferences and settings for a personalized experience.</li>
            <li><strong>Advertising Cookies:</strong> Used by third-party advertisers to display relevant ads based on your browsing behavior.</li>
          </ul>
          
          <h2>3. How We Use Cookies</h2>
          <p>We use cookies to:</p>
          <ul>
            <li>Ensure our Website functions correctly.</li>
            <li>Improve Website performance and user experience.</li>
            <li>Analyze traffic and user interactions.</li>
            <li>Deliver personalized content and advertisements.</li>
          </ul>
          
          <h2>4. Managing Your Cookie Preferences</h2>
          <p>You can control and manage cookies through your browser settings. You may:</p>
          <ul>
            <li>Accept or reject cookies.</li>
            <li>Delete stored cookies.</li>
            <li>Set preferences for certain websites.</li>
          </ul>
          <p>Please note that disabling cookies may affect the functionality of our Website.</p>
          
          <h2>5. Third-Party Cookies</h2>
          <p>We may allow third-party services (such as analytics providers and advertisers) to use cookies on our Website. These third parties have their own privacy and cookie policies, and we do not control their use of cookies.</p>
          
          <h2>6. Changes to This Cookie Policy</h2>
          <p>We may update this Cookie Policy from time to time. Continued use of our Website after any changes signifies your acceptance of the updated policy.</p>
          
          <h2>7. Contact Information</h2>
          <p>If you have any questions about this Cookie Policy, please <Link to="/" className="text-[#29b554] hover:underline">contact us</Link>.</p>
        </div>
      </div>
    </div>
  )
}

export default CookiePolicy
